import { Typography, Box, Button, MenuItem } from "@mui/material";
import styles from "../../index.module.scss";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import TableComponent from "../../../components/TableComponent";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState, appActions } from "../../../store/app";
import AddIcon from "@mui/icons-material/Add";
import Storage from "../../../utils/storage";
import LoadingContainer from "../../../components/LoadingContainer";
import { useTranslation } from "../../../i18n";
import PopupMenu from "../../../components/PopupMenu";
import ConfirmModal from "../../../components/ConfirmModal";
import { deleteAction } from "../../../store/app/appActions";
import SearchComponent from "../../../components/SearchComponent";
import ChipComponent, { ChipData } from "../../../components/ChipComponent";
import { LoadingButton } from "@mui/lab";
import { liveStockActions, LiveStockState } from "../../../store/pig";
import { Birth, birthColumns, BirthRow } from "../../../interfaces/Pig/birth";
import {
  exportBirthsAction,
  getBirthsAction,
  searchBirthAction,
} from "../../../store/pig/birth/birthActions";
import AddBirth from "./AddBirth";
import FilterBirth from "./FilterBirth";
import BirthView from "./BirthView";
import { deleteBirthService } from "../../../store/pig/birth/birthService";
import moment from "moment";
import { numberWithCommas } from "../../../utils/functions";
import AssignEarTags from "./AssignEarTags";
import { PigState } from "../../../store/pigSlice";

const Births = (props: any) => {
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(50);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [query, setQuery] = useState("");
  const [isInit, setIsInit] = useState(true);
  const [assignEarTags, setAssignEarTags] = useState(false);
  const dispatch = useDispatch();
  const appState: AppState = useSelector((state: any) => state.app);
  const liveStockState: LiveStockState = useSelector(
    (state: any) => state.liveStock
  );
  const pigState: PigState = useSelector((state: any) => state.pig);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [chipData, setChipData] = useState([]);
  const [birth, setBirth] = useState<any>();
  const [viewBirth, setViewBirth] = useState<boolean>();
  const open = Boolean(anchorEl);
  const token = Storage.getToken();
  const { t } = useTranslation();

  // useEffect(() => {
  //   dispatch(
  //     getBirthsAction(
  //       `?page=${page}&sort=-createdAt&limit=${rowsPerPage}`,
  //       token
  //     )
  //   );
  // }, []);

  useEffect(() => {
    if (!liveStockState.fetchedBirth) {
      dispatch(
        getBirthsAction(
          `?page=${page}&sort=-date&grown=false&limit=${rowsPerPage}${query}`,
          token
        )
      );
    }
  }, [dispatch, liveStockState.fetchedBirth, page, query, rowsPerPage, token]);

  useEffect(() => {
    if (!appState.isFetching) {
      setCount(appState.count);
    }
  }, [appState.isFetching, appState.count]);

  useEffect(() => {
    if (chipData.length > 0) {
      let queryString = "";
      chipData.forEach((data: any) => {
        queryString += `&${data.id}=${data.filter}`;
      });
      setQuery(queryString);
      dispatch(liveStockActions.setFetchedBirth(false));
    } else if (chipData.length === 0 && query !== "") {
      setQuery("");
      dispatch(liveStockActions.setFetchedBirth(false));
    }
  }, [chipData, dispatch, query]);

  useEffect(() => {
    let timer = setTimeout(() => {
      if (searchText) {
        dispatch(searchBirthAction(`?text=${searchText}`, token));
        setIsInit(false);
      } else {
        if (!appState.isFetching && !isInit) {
          dispatch(liveStockActions.setFetchedBirth(false));
        }
      }
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [appState.isFetching, dispatch, isInit, searchText, token]);

  const createData = (birth: Birth): BirthRow => {
    return {
      date: birth?.date?.substring(0, 10),
      sow: birth?.reproduction?.sow?.earTag,
      birth: birth?.boars + birth?.sows,
      remaining: birth?.boarsLeft + birth?.sowsLeft,
      boarsSowsRemaining: `${birth?.boarsLeft} | ${birth?.sowsLeft}`,
      days: -moment(birth?.date?.substring(0, 10)).diff(moment.now(), "days"),
      cost: `${numberWithCommas(birth?.costEstimate)} RWF`,
      action: (
        <button
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
            setBirth(birth);
            setAnchorEl(event.currentTarget);
          }}
          className={styles.actionsIcon}
        >
          •••
        </button>
      ),
    };
  };

  const handlePageChange = (event: unknown, newPage: number) => {
    setPage(newPage);
    dispatch(liveStockActions.setFetchedBirth(false));
  };

  const filterHandler = (filterData: any) => {
    setChipData(filterData);
  };

  const handleChipDelete = (chipToDelete: ChipData) => {
    setChipData((chips) =>
      chips.filter((chip: ChipData) => chip.key !== chipToDelete.key)
    );
  };

  const exportExcelHandler = () => {
    dispatch(exportBirthsAction("?limit=1000", token, t("births")));
  };

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    dispatch(liveStockActions.setFetchedBirth(false));
  };

  const deleteReproductionHandler = () => {
    dispatch(
      deleteAction(
        deleteBirthService,
        birth?._id,
        token,
        t("births"),
        () => {},
        () => dispatch(liveStockActions.setFetchedBirth(false))
      )
    );
  };

  const rows = pigState.births?.map((birth: Birth) => createData(birth));

  return (
    <>
      <Box className={styles.topContainer}>
        <Box>{t("welcome")}</Box>
        <Box className={styles.dFlex}>
          <SearchComponent setSearchText={setSearchText} />
          <LoadingButton
            variant="contained"
            startIcon={<SaveAltIcon />}
            loading={appState.isExportingExcel}
            onClick={exportExcelHandler}
            className={styles.exportExcelButton}
          >
            {t("exportExcel")}
          </LoadingButton>
        </Box>
      </Box>
      {appState.isFetching && <LoadingContainer />}
      {!appState.isFetching && (
        <>
          {chipData.length > 0 && (
            <ChipComponent
              chipData={chipData}
              handleDelete={handleChipDelete}
            />
          )}
          <Box className={styles.tableTopActions}>
            <Box>
              <Typography>{t("births")}</Typography>
            </Box>
            <Box>
              <Button
                onClick={() => dispatch(appActions.setOpenFilter(true))}
                startIcon={<AddIcon />}
              >
                {t("filter")}
              </Button>
              <Button
                onClick={() =>
                  dispatch(
                    appActions.setOpenForm({ open: true, action: "add" })
                  )
                }
                startIcon={<AddIcon />}
              >
                {t("addNew")}
              </Button>
            </Box>
          </Box>
          <TableComponent
            rows={rows}
            columns={birthColumns}
            count={count}
            page={page}
            rowsPerPage={rowsPerPage}
            handlePageChange={handlePageChange}
            handleRowsPerPageChange={handleRowsPerPageChange}
          />
          {open && (
            <PopupMenu
              anchorEl={anchorEl}
              onClose={() => setAnchorEl(null)}
              onView={() => setViewBirth(true)}
              onUpdate={() =>
                dispatch(
                  appActions.setOpenForm({ open: true, action: "update" })
                )
              }
              onDelete={() => dispatch(appActions.setIsDeleting(true))}
            >
              <MenuItem
                onClick={() => {
                  setAssignEarTags(true);
                  setAnchorEl(null);
                }}
              >
                <LocalOfferIcon />
                <Typography>{t("Gucutsa")}</Typography>
              </MenuItem>
            </PopupMenu>
          )}
          {assignEarTags && (
            <AssignEarTags
              open={assignEarTags}
              close={() => setAssignEarTags(false)}
              birth={birth}
              styles="horizontal"
            />
          )}
          {appState.isDeleting && (
            <ConfirmModal
              onConfirm={() => deleteReproductionHandler()}
              content={`${t(
                "confirmDeleteDesc"
              )} urubyaro rw'inyangazi ifite iherena:  ${
                birth?.reproduction?.sow?.earTag
              } ?`}
            />
          )}
          {appState.openForm.open && <AddBirth birth={birth} />}
          {appState.openFilter && (
            <FilterBirth
              open={appState.openFilter}
              close={() => dispatch(appActions.setOpenFilter(false))}
              filterHandler={filterHandler}
            />
          )}
          {viewBirth && (
            <BirthView
              open={viewBirth}
              onClose={() => setViewBirth(false)}
              birth={birth}
            />
          )}
        </>
      )}
    </>
  );
};

export default Births;
